import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TableConfig } from "@app/shared/util/table-config.utils";
import { Log } from "ng2-logger";
import { ToolRequest } from "@models/toolRequests.model";
import { ToolRequestStatus } from "@app/tool/model/enums/tool-request-status.enum";

@Component({
    selector: 'app-tool-requests-facilities-table',
    templateUrl: './tool-requests-facilities-table.component.html',
    styleUrls: ['./tool-requests-facilities-table.component.scss']
})
export class ToolRequestsFacilitiesTableComponent {
    _logger = Log.create(ToolRequestsFacilitiesTableComponent.name);

    @Input() toolRequests: ToolRequest[] = [];
    @Input() tableConfig: TableConfig;
    @Input() isLoading: false;
    @Input() statusFilters = [];
    @Input() headerBackgroundColor: string;
    @Input() hasTitle = true;

    @Output() pageChange = new EventEmitter<any>();
    @Output() filterChange = new EventEmitter<any>();
    @Output() sortChange = new EventEmitter<any>();
    @Output() rowClick = new EventEmitter<any>();
    @Output() processClick = new EventEmitter<any>();
    @Output() resumeClick = new EventEmitter<any>();


    onPageChange(tableConfig: TableConfig) {
        this.pageChange.emit(tableConfig);
    }

    onSortChange(tableConfig: TableConfig) {
        this.sortChange.emit(tableConfig);
    }

    onFilterChange(tableConfig: TableConfig) {
        this.filterChange.emit(tableConfig);
    }

    process(toolRequest) {
        this.processClick.emit(toolRequest);
    }

    resume(toolRequest) {
        this.resumeClick.emit(toolRequest);
    }

    shouldRenderProcess(toolRequest) {
        return toolRequest.status === ToolRequestStatus.NEW;
    }

    shouldRenderResume(toolRequest) {
        return toolRequest.status === ToolRequestStatus.WAITING_FOR_APPROVAL;
    }
}
